<div class="animate__animated animate__fadeInLeft animate__faster">
    <div class="px-8 py-6 mt-8 max-w-3xl mx-auto ">
        <h1 class="text-4xl font-bold"></h1>
    </div>

    <div class="px-8 py-6 mt-8 max-w-3xl mx-auto border border-transparent rounded-3xl shadow-lg">
        <div class="py-5">
            <h2 class="text-lg font-bold">Ingresa tu Email</h2>
            <hr class="text-gray-300 w-full">
        </div>
        <form [formGroup]="sendEmail" class=" grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="space-y-1 md:col-span-1">
                <label for="email" class="block text-sm font-medium text-gray-300">Email</label>
                <input type="text" name="email" formControlName="email" id="email" class="block w-full py-2.5 px-3 text-sm text-gray-900 bg-transparent border border-gray-300 focus:outline-none focus:border-blue-600 dark:text-white dark:border-gray-600 dark:focus:border-blue-500 rounded-full" placeholder="Email" required />
                @for(validation of validationMessages.email!;track $index){
                    @if(getValidationSendEmailFromControl(validation, 'email')) {
                        <div>
                            <span class="mt-2 text-sm text-red-600 dark:text-red-500" style="color:red;"> {{ validation.message }} </span>
                        </div>
                    }
                }
            </div>
        </form>
        <div class="py-4 mt-5 flex justify-center md:justify-end">
            @if ($isLoading | async) {
                <button disabled type="button" class="flex justify-center bg-purple-600 text-white w-60 h-14 rounded-full font-bold focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 inline-flex items-center">
                    <svg aria-hidden="true" role="status" class="inline w-4 h-4 me-3 text-gray-200 animate-spin dark:text-gray-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="#1C64F2"/>
                    </svg>
                    Cargando...
                </button>
            } @else {
                <button class="bg-purple-600 text-white w-60 h-14 rounded-full font-bold" (click)="onContinue()"
                        [disabled]="!sendEmail.valid"
                        [class.opacity-50]="!sendEmail.valid">
                    Continuar
                </button>
            }
        </div>
    </div>
</div>
